<template>
    <table class="tabela tabela_listrada tabela_com-largura-total">
        <thead>
            <tr>
                <th>Valor</th>
                <th>Usuário</th>
                <th>Data</th>
            </tr>
        </thead>
        <tbody>
            <tr v-for="aporte in aportes" :key="aporte.Id">
                <td>{{ $moeda.formatar(aporte.Valor) }}</td>
                <td>{{ aporte.Usuario.Nome }}</td>
                <td>{{ $tempo.formatarParaPadraoBrasileiro(aporte.Data) }}</td>
            </tr>
            <tr v-if="aportes.length === 0">
                <td colspan="3">Nenhum aporte foi encontrado</td>
            </tr>
        </tbody>
    </table>
</template>

<script>
export default {
    name: "TabelaAportes",
    props: {
        aportes: {
            type: Array,
            required: true,
        },
    },
};
</script>


// WEBPACK FOOTER //
// TabelaDeAportes.vue?bf78bf20